import {type NormalizedConstraints} from '@packages/systems/constraints-types';

export const noConstraints: NormalizedConstraints = {
  wraps: [],
  pinToParent: false,
  ancestors: [],
  parent: [],
  descendants: [],
  children: [],
  page: [],
};
